import script from "./highPredictAddtional.vue?vue&type=script&setup=true&lang=js"
export * from "./highPredictAddtional.vue?vue&type=script&setup=true&lang=js"

import "./highPredictAddtional.vue?vue&type=style&index=0&id=70c073de&lang=less&scoped=true"

import exportComponent from "D:\\workspaceJava\\wlyc\\wlyc\\tianjing-client-web-develop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70c073de"]])

export default __exports__